export default __webpack_public_path__ + "assets/images/Delete-09f51c300e5560d404223205ca58b4cd.svg";